import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/inquiry-form/ui/inquiry-form.tsx");
